import cx from 'classnames'

type Layer =
  | 'tips' // topmost for e.g. portaled tooltips and fullscreen loaders
  | 'globalModals' // global modals and dialogs
  | 'modals' // modals and dialogs
  | 'bars' // top app bars and bottom navigation/settings
  | 'scrollShadow' // shadow for scrollable content
  | 'popovers' // popovers and dropdowns
  | 'popoverBackdrop' // backdrop for popovers
  | 'sticky' // sticky components (e.g. headers on tables)
  | 'yoloDontUse' // for external library-only components that should always be on top of everything else

export const zIndexStyles = (layer: Layer) =>
  (
    ({
      tips: cx('z-50'),
      globalModals: cx('z-45'),
      modals: cx('z-40'),
      bars: cx('z-30'),
      scrollShadow: cx('z-29'), // hardcoded in the base.css but added here for documentation purposes
      popovers: cx('z-20'),
      popoverBackdrop: cx('z-19'),
      sticky: cx('z-10'),
      yoloDontUse: cx('z-100'),
    }) satisfies Record<Layer, string>
  )[layer]
